export const LOCALSTORAGEKEYS = {
  ACCESSTOKEN: "accessToken", // Token to access the app
  EXPIRATION: "expiration", // Token expiration --> User will be automatically logged out
  REFRESHTOKEN: "refreshToken", // for refreshing the token
  USERNAME: "username", // Username
  USER: "user", // Userobject
  SSOTOKEN: "ssoToken", //SSO Token
  LOGINTYPE: "login_type",
  CURRENT_WORKSPACE: "current_workspace", //Current Workspace to load on login
  CURRENT_WORKSPACE_NAME: "CURRENT_WORKSPACE_NAME", //Current Workspace name to load on login
  REPORTCONFIG: "reporting_config", // embedded token is safed here + all reportings of workspace
  FAVOURITES: "favourites", // favourites bookmark reports
};

export const SESSIONSTORAGEKEYS = {
  EXPIRATION_REPORT: "expiration", // Token expiration --> Until Report is not available
  TO_REDIRECT_PAGE: "to_redirect_page", // Page after logged in to redirect
};

export const PERMISSIONS = {
  VIEW_REPORT: "view_report",
  EDIT_REPORT: "edit_report",
  ADD_REPORT: "add_report",
  SHARE_REPORT_EXTERN: "share_reporting_extern",
  SHARE_REPORT_INTERN: "share_reporting_intern",
  ADD_TAG: "add_tag",
  EDIT_TAG: "edit_tag",
  ADD_REPORT_TAG: "add_report_tag",
  EDIT_REPORT_TAG: "edit_report_tag",
};
